import { Box, Button, ButtonBase, Card, CardContent, CardMedia, Grid, List, ListItem, Modal, Stack, Step, StepLabel, Stepper, Tab, Typography } from "@mui/material";
import CancelIcon from "../../../icons/close.svg";
import BackIcon from "../../../icons/back1.svg";
import { makeStyles } from "@mui/styles";
import React from "react";
import LinkIcon from "../../../icons/LinkIcon.svg";
import Tick from "../../../icons/Tick.svg";
import AcceptChargeback from "../../../icons/AcceptChargeback.svg";
import DisputeChargeback from "../../../icons/DisputeChargeback.svg";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import NumberFormat from "react-number-format";
import { convertCentsToDollars } from "../../../shared/util/converters";
import { useDispatch, useSelector } from "react-redux";
import { getChangeChargebackStatus, selectPMPaymentState } from "../sagas/pmTransactionsSlice";
import SpinnerWithNoConfirmation from "../../../shared/Modal/spinnerWithNoConfirmation";
import { PaymentActionDto, ValidRequestMessages, ValidTransactionStatusEnum } from "@inosio/payments-sdk";
import { format } from "date-fns";

export interface ChargebackDetailsModalProps {
  open: boolean;
  onClose: () => void;
  chargebackStatus: ValidTransactionStatusEnum | undefined;
  paymentID: string;
}

const useStyles = makeStyles((theme) => ({
  globalError: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "10px",
    borderTop: "2px  solid #DB3939",
    borderRadius: "24px",
    padding: "12px 20px",
    width: "360px",
    height: "49px",
    justifyContent: "center",
  },
  buttonContainer: {
    position: "absolute",
    bottom: 15,
    right: 20,
  },
  wrapper: {
    margin: "1px",
    position: "relative",
  },
  stepperContainer: {
    marginTop: "90px",
    width: "100%",
  },
  stepper: {
    width: "100%",
    "& .MuiStepLabel-root": {
      display: "flex",
      flexDirection: "column-reverse !important",
      marginTop: "-65px",
    },
    "& .MuiStepLabel-label": {
      display: "flex",
      justifyContent: "center",
    },
    "& .MuiStepLabel-labelContainer": {
      marginBottom: "9px",
    },
    "& .MuiStepConnector-root": {
      top: "-5px",
    },
    "& .MuiStepIcon-root": {
      color: "#F1F0F5",
      width: "29px",
      height: "29px",
    },
    "& .MuiStepIcon-root.Mui-completed": {
      color: "#39DB8D",
    },
    "& .MuiStepIcon-root .MuiStepIcon-text": {
      fill: "#14142B",
      fontWeight: "600",
    },
    "& .MuiStepIcon-root.Mui-active": {
      color: "#39DB8D",
    },
    "& .MuiStepIcon-root.Mui-active .MuiStepIcon-text": {
      fill: "#fff",
    },
  },
  stepperText: {
    fontFamily: "Work Sans !important",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "15px !important",
    lineHeight: "21px !important",
    maxWidth: "120px",
    color: "#14142B",
  },
  termsAndConditionLink: {
    fontFamily: "Work Sans",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#39A2DB",
    marginTop: "18px",
    cursor: "pointer",
  },
  textStyle: {
    fontFamily: "Work Sans !important",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "15px !important",
    lineHeight: "21px !important",
    color: "#14142B",
  },
  textStyleConfirmation: {
    fontFamily: "Work Sans !important",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "18px !important",
    lineHeight: "21px !important",
    color: "#14142B",
  },
  headingStyleConfirmation: {
    fontFamily: "Work Sans !important",
    fontStyle: "normal",
    fontWeight: "700px",
    fontSize: "18px !important",
    lineHeight: "21px !important",
    color: "#14142B",
  },
}));

function ChargebackDetailsModal(props: ChargebackDetailsModalProps) {
  const [activeStep, setActiveStep] = React.useState(0);
  const [acceptCB, setAcceptCB] = React.useState(false);
  const [disputeCB, setDisputeCB] = React.useState(false);
  const [value, setValue] = React.useState("1");
  const dispatch = useDispatch();
  const { chargebackDetails, isFetchingChargebackDetails, isChangingChargebackStatus, ErrorChargebackDetails, ErrorChargebackStatusChange } = useSelector(selectPMPaymentState);
  const { chargeBackDate, chargeBackAmount, chargeBackReason, payeeName, payeeType, payerEmail, payerName, payerPhone, payerType, cardHolderName, cardNumber, IpAddress } = chargebackDetails;

  const classes = useStyles();
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "16px",
    height: "555px",
    pointerEvents: "auto",
    width: "520px",
    borderRadius: "24px",
  };

  const steps = ["Things to know", "Details", "What's next"];

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step: number) => () => {
    setActiveStep(step);
  };

  const handleNext = () => {
    if (activeStep < 3) {
      const newActiveStep = activeStep + 1;
      setActiveStep(newActiveStep);
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const handleClose = () => {
    setActiveStep(0);
    setAcceptCB(false);
    setDisputeCB(false);
  };

  const formatChargebackDate = (cbDate: string) => {
    if (cbDate) {
      return format(new Date(cbDate), "P")
      
    } else return "";
  };

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      BackdropProps={{
        invisible: true,
      }}
      disableEscapeKeyDown
    >
      <Card sx={style}>
        {isFetchingChargebackDetails || isChangingChargebackStatus ? (
          <Grid item xs={12}>
            <Stack direction="column" justifyContent="center" alignItems="center" style={{ height: "50vh" }}>
              <SpinnerWithNoConfirmation />
            </Stack>
          </Grid>
        ) : (
          <>
            {ErrorChargebackDetails || ErrorChargebackStatusChange ? (
              <Grid item sx={{display:'flex', justifyContent:'center'}}>
                <div className={classes.globalError}>
                  <Typography
                    sx={{
                      fontFamily: "'Open Sans', sans-serif",
                      fontStyle: "normal",
                      fontWeight: 500,
                      fontSize: "14px",
                      lineHeight: "18px",
                      color: "#DB3939",
                    }}
                  >
                    {ErrorChargebackDetails || ErrorChargebackStatusChange}
                  </Typography>
                </div>
              </Grid>
            ) : (
              ""
            )}
            <Grid item sx={{ position: "absolute", top: 18, right: 20 }}>
              <img
                src={CancelIcon}
                alt="close"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleClose();
                  props.onClose();
                }}
              />
            </Grid>
            {/*if user has not chosen accept or dispute, then don't show Accept CB and Dispute CB confirmations*/}
            {((!acceptCB && !disputeCB) || ErrorChargebackStatusChange.length > 0) && (
              <>
                <Grid item sx={{ position: "absolute", top: 18, left: 20, display: activeStep === 0 ? "none" : "" }}>
                  <img src={BackIcon} alt="close" style={{ cursor: "pointer" }} onClick={handleBack} />
                </Grid>
                {/* if chargeback status is received, only then show the stepper (journey)*/}
                {props.chargebackStatus && props.chargebackStatus?.includes("Chargeback Received") && (
                  <Box className={classes.stepperContainer} sx={{ display: "block" }}>
                    <Stepper nonLinear alternativeLabel activeStep={activeStep} classes={{ root: classes.stepper }}>
                      {steps.map((label, index) => (
                        <Step key={label}>
                          <StepLabel sx={{ display: "flex", justifyContent: "center", cursor: "pointer" }} onClick={handleStep(index)}>
                            <Typography className={classes.stepperText}>{label}</Typography>
                          </StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </Box>
                )}

                <Grid container sx={{ marginTop: "10px", height: "370px" }}>
                  {/* On stepper 1, show only when CB received*/}
                  {activeStep === 0 && props.chargebackStatus?.includes("Chargeback Received") && (
                    <Grid item sx={{ width: "100%", height: "100%" }}>
                      <List
                        sx={{
                          listStyleType: "disc",
                          pl: 4,
                          "& .MuiListItem-root": {
                            display: "list-item",
                          },
                          fontFamily: "Work Sans !important",
                          fontStyle: "normal",
                          fontWeight: "400",
                          fontSize: "15px !important",
                          lineHeight: "21px !important",
                          color: "#14142B",
                        }}
                      >
                        <ListItem>
                          {`Property Managers (compared to a retailer) are in a good position to reclaim chargedback funds. However, that is typically accomplished by dealing directly with the tenant - not by disputing with the card network.`}
                        </ListItem>
                        <ListItem>{`Chargebacks are issued by the cardholder NOT necessarily the tenant.`}</ListItem>
                        <ListItem>{`To win a chargeback dispute you need to provide proof that the cardholder authorized the transaction.`}</ListItem>
                      </List>
                      <Grid item pt={4} sx={{ display: "flex", justifyContent: "center" }}>
                        <Typography>
                          <span
                            style={{
                              cursor: "pointer",
                            }}
                            className={classes.termsAndConditionLink}
                            onClick={() => {
                              window.open("https://support.inosio.com/article/chargebacks");
                            }}
                          >
                            You should know this information about chargebacks.
                          </span>
                          <img src={LinkIcon} alt="link" />
                        </Typography>
                      </Grid>
                    </Grid>
                  )}
                  {/* On stepper 2, show it for all CB statuses,
          Do not show only when user clicks on accept or dispute CB */}
                  {(activeStep === 1 || !props.chargebackStatus?.includes("Chargeback Received")) && (
                    <Grid item mt={props.chargebackStatus?.includes("Chargeback Received") ? 0 : 4}>
                      <TabContext value={value}>
                        <Grid item display="flex" justifyContent="center">
                          <Box>
                            <TabList onChange={handleChange}>
                              <Tab label="Chargeback Details" value="1" style={{ marginRight: "70px", textTransform: "none", color: "#39A2DB" }} />
                              <Tab label="Inosio Payer Details" value="2" style={{ textTransform: "none", color: "#39A2DB" }} />
                            </TabList>
                          </Box>
                        </Grid>
                        <Box>
                          <TabPanel value="1">
                            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                              <Grid item xs={7}>
                                <Typography id="review-submit-sub-details">Chargeback Date</Typography>
                              </Grid>
                              <Grid item xs={5}>
                                <Typography id="review-submit-sub-details">{formatChargebackDate(chargeBackDate)}</Typography>
                              </Grid>
                              <Grid item xs={7}>
                                <Typography id="review-submit-sub-details">Amount</Typography>
                              </Grid>
                              <Grid item xs={5}>
                                <Typography id="review-submit-sub-details">
                                  <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={convertCentsToDollars(chargeBackAmount)}
                                    prefix="$"
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    allowNegative={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                  />
                                </Typography>
                              </Grid>
                              <Grid item xs={7}>
                                <Typography id="review-submit-sub-details">Card #</Typography>
                              </Grid>
                              <Grid item xs={5}>
                                <Typography id="review-submit-sub-details">{cardNumber}</Typography>
                              </Grid>
                              <Grid item xs={7}>
                                <Typography id="review-submit-sub-details">Cardholder Name</Typography>
                              </Grid>
                              <Grid item xs={5}>
                                <Typography id="review-submit-sub-details">{cardHolderName}</Typography>
                              </Grid>
                              <Grid item xs={7}>
                                <Typography id="review-submit-sub-details">Chargeback Reason</Typography>
                              </Grid>
                              <Grid item xs={5}>
                                <Typography id="review-submit-sub-details">{chargeBackReason}</Typography>
                              </Grid>
                            </Grid>
                          </TabPanel>
                          <TabPanel value="2">
                            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                              <Grid item xs={7}>
                                <Typography id="review-submit-sub-details">{`${payerType} Account`}</Typography>
                              </Grid>
                              <Grid item xs={5}>
                                <Typography id="review-submit-sub-details">{payerName}</Typography>
                              </Grid>
                              <Grid item xs={7}>
                                <Typography id="review-submit-sub-details">{`${payeeType}`}</Typography>
                              </Grid>
                              <Grid item xs={5}>
                                <Typography id="review-submit-sub-details">{payeeName}</Typography>
                              </Grid>
                              <Grid item xs={7}>
                                <Typography id="review-submit-sub-details">Email</Typography>
                              </Grid>
                              <Grid item xs={5}>
                                <Typography id="review-submit-sub-details">{payerEmail}</Typography>
                              </Grid>
                              <Grid item xs={7}>
                                <Typography id="review-submit-sub-details">Phone</Typography>
                              </Grid>
                              <Grid item xs={5}>
                                <Typography id="review-submit-sub-details">{payerPhone}</Typography>
                              </Grid>
                              <Grid item xs={7}>
                                <Typography id="review-submit-sub-details">IP Address</Typography>
                              </Grid>
                              <Grid item xs={5}>
                                <Typography id="review-submit-sub-details">{IpAddress}</Typography>
                              </Grid>
                            </Grid>
                          </TabPanel>
                        </Box>
                      </TabContext>
                    </Grid>
                  )}

                  {/* On stepper 3, show only when CB received*/}
                  {activeStep === 2 && props.chargebackStatus?.includes("Chargeback Received") && (
                    <Grid item sx={{ width: "100%", height: "100%" }}>
                      <List
                        sx={{
                          listStyleType: "disc",
                          pl: 4,
                          "& .MuiListItem-root": {
                            display: "list-item",
                          },
                          fontFamily: "Work Sans !important",
                          fontStyle: "normal",
                          fontWeight: "400",
                          fontSize: "15px !important",
                          lineHeight: "21px !important",
                          color: "#14142B",
                        }}
                      >
                        <ListItem>{`Contact the tenant and let them know that their payment has been chargedback. They owe you these funds.`}</ListItem>
                        <ListItem>{`The tenant is solely responsible for rectifying the situation by paying you directly OR contacting the cardholder/bank to resolve the dispute from their end.`}</ListItem>
                        <ListItem>{`After disucssing with the tenant you can proceed to the next page.`}</ListItem>
                      </List>
                    </Grid>
                  )}

                  {/* Dispute or Accept screen, show only when CB received */}
                  {activeStep === 3 && props.chargebackStatus?.includes("Chargeback Received") && (
                    <Grid item sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                      <Grid item pl={4} pr={4}>
                        <Typography className={classes.textStyle}>If you’d like to dispute the chargeback and you have proof that the cardholder authorized the transaction then click ‘Start Dispute’.</Typography>
                      </Grid>
                      <Card
                        sx={{
                          padding: "0",
                          width: 340,
                          boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.1)",
                          borderRadius: "20px",
                          marginTop: "52px !important",
                        }}
                      >
                        <ButtonBase
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            width: "100%",
                            padding: "15px 22px",
                            textAlign: "initial",
                          }}
                          onClick={() => {
                            setAcceptCB(true);
                            dispatch({
                              type: getChangeChargebackStatus.type,
                              transactionUUID: props.paymentID,
                              payload: {
                                status: ValidRequestMessages.Acceptchargeback,
                              } as PaymentActionDto,
                            });
                          }}
                          id={"invitation-email"}
                        >
                          <CardMedia component="img" sx={{ width: 67, marginRight: "15px" }} image={AcceptChargeback} alt="Invitation Email" />
                          <CardContent>
                            <Typography
                              sx={{
                                fontFamily: "Work Sans",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: "18px",
                                lineHeight: "23px",
                                color: "#14142B",
                              }}
                            >
                              Accept Chargeback
                            </Typography>
                            <Typography
                              sx={{
                                fontFamily: "Work Sans",
                                fontStyle: "normal",
                                fontWeight: 500,
                                fontSize: "12px",
                                lineHeight: "14px",
                                color: "#14142B",
                              }}
                            >
                              Deal with the tenant directly
                            </Typography>
                          </CardContent>
                        </ButtonBase>
                      </Card>
                      <Card
                        sx={{
                          padding: "0",
                          width: 340,
                          boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.1)",
                          borderRadius: "20px",
                          marginTop: "30px !important",
                        }}
                      >
                        <ButtonBase
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "start",
                            width: "100%",
                            padding: "15px 0 15px 18px",
                            textAlign: "initial",
                          }}
                          onClick={() => {
                            setDisputeCB(true);
                            dispatch({
                              type: getChangeChargebackStatus.type,
                              transactionUUID: props.paymentID,
                              payload: {
                                status: ValidRequestMessages.Disputechargeback,
                              } as PaymentActionDto,
                            });
                          }}
                          id={"special-code"}
                        >
                          <CardMedia component="img" sx={{ width: 67, marginRight: "17px" }} image={DisputeChargeback} alt="Invitation Email" />
                          <CardContent>
                            <Typography
                              sx={{
                                fontFamily: "Work Sans",
                                fontStyle: "normal",
                                fontWeight: 700,
                                fontSize: "18px",
                                lineHeight: "23px",
                                color: "#14142B",
                              }}
                            >
                              Start Dispute
                            </Typography>
                            <Typography
                              sx={{
                                fontFamily: "Work Sans",
                                fontStyle: "normal",
                                fontWeight: 500,
                                fontSize: "12px",
                                lineHeight: "14px",
                                color: "#14142B",
                              }}
                            >
                              Dispute with the card network
                            </Typography>
                          </CardContent>
                        </ButtonBase>
                      </Card>
                    </Grid>
                  )}
                </Grid>
                {/* Show only in the journey when CB received */}
                {props.chargebackStatus?.includes("Chargeback Received") && (
                  <Box className={classes.buttonContainer}>
                    <Button
                      variant="contained"
                      style={{
                        textTransform: "none",
                        fontFamily: "'Open Sans', sans-serif",
                        fontStyle: "normal",
                        fontWeight: 700,
                        backgroundColor: "#39A2DB",
                        borderRadius: "24px",
                        width: "115px",
                        display: activeStep < 3 ? "" : "none",
                      }}
                      onClick={handleNext}
                    >
                      Continue
                    </Button>
                  </Box>
                )}
              </>
            )}

            {/* Confirmation content in case of accepting or disputing CB */}
            {(acceptCB || disputeCB) && !ErrorChargebackStatusChange && (
              <Grid item sx={{ height: "100%", width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <Grid item pl={4} pr={4}>
                  <Typography textAlign={"center"} style={{ fontWeight: 600 }} className={classes.headingStyleConfirmation}>
                    {acceptCB ? "Chargeback Accepted" : "Chargeback Disputed"}
                  </Typography>
                </Grid>
                <Grid item mt={10}>
                  <img src={Tick} alt="tick" />
                </Grid>
                <Grid item pl={4} pr={4} mt={2}>
                  <Typography textAlign={"center"} className={classes.textStyleConfirmation}>
                    {acceptCB ? "The chargeback has been accepted. No further action is required." : "A dispute has been initiated. Check your inbox!"}
                  </Typography>
                </Grid>
                {/* Additional sentences for dispute */}
                {disputeCB && (
                  <>
                    <Grid item pl={4} pr={4} mt={2}>
                      <Typography textAlign={"center"} className={classes.textStyleConfirmation}>
                        You will receive an email from Inosio with the next steps. You will be required to provide documentation that the cardholder authorized the payment.
                      </Typography>
                    </Grid>
                    <Grid item pl={4} pr={4} mt={2}>
                      <Typography textAlign={"center"} className={classes.textStyleConfirmation}>
                        Disputes generally take 15 - 45 days to be resolved after your dispute package is received.
                      </Typography>
                    </Grid>
                  </>
                )}
              </Grid>
            )}
          </>
        )}
      </Card>
    </Modal>
  );
}

export default ChargebackDetailsModal;
